class s extends HTMLElement{connectedCallback(){this.closest(".cl-section")?.addEventListener("cl:accordion:open",i=>{const n=i.detail.item.dataset.index,t=Array.from(this.querySelectorAll(".cl-ia__img")),c=t.find(e=>e.dataset.index===n)??t.find(e=>e.dataset.index==="-1")??t[0];t.forEach(e=>{e.classList.toggle("is-active",e===c),e===c?e.removeAttribute("aria-hidden"):e.setAttribute("aria-hidden","true")})})}}customElements.get("cl-image-accordion")||customElements.define("cl-image-accordion",s);

const lineSplitState = new WeakMap();

function splitRenderedLines(body) {
  const state = lineSplitState.get(body);
  if (!state || body.clientWidth === 0) return;

  body.innerHTML = state.html;
  const blocks = Array.from(body.children);
  const lines = [];

  blocks.forEach((block, blockIndex) => {
    const words = block.textContent.trim().split(/\s+/).filter(Boolean);
    if (!words.length) return;
    let firstLineInBlock = true;

    block.textContent = '';
    words.forEach((word, index) => {
      if (index) block.append(' ');
      const span = document.createElement('span');
      span.textContent = word;
      span.style.whiteSpace = 'nowrap';
      block.append(span);
    });

    let top = null;
    let text = '';
    Array.from(block.children).forEach((word) => {
      const wordTop = Math.round(word.getBoundingClientRect().top);
      if (top !== null && wordTop !== top) {
        lines.push({ text, paragraph: blockIndex > 0 && firstLineInBlock });
        firstLineInBlock = false;
        text = '';
      }
      top = wordTop;
      text += `${text ? ' ' : ''}${word.textContent}`;
    });
    if (text) lines.push({ text, paragraph: blockIndex > 0 && firstLineInBlock });
  });

  const original = document.createElement('div');
  original.className = 'cl-sr-only';
  original.innerHTML = state.html;

  body.replaceChildren(...lines.map((line, index) => {
    const div = document.createElement('div');
    div.className = `cl-ia__line${line.paragraph ? ' cl-ia__line--paragraph' : ''}`;
    div.setAttribute('aria-hidden', 'true');
    div.style.setProperty('--cl-line-index', index);
    div.textContent = line.text;
    return div;
  }), original);

  if (body.closest('.cl-acc__item')?.classList.contains('is-open')) {
    requestAnimationFrame(() => body.querySelectorAll('.cl-ia__line').forEach(line => line.classList.add('is-visible')));
  }
}

function isPlainParagraphs(body) {
  return Array.from(body.childNodes).every((node) =>
    node.nodeType === Node.TEXT_NODE
      ? !node.textContent.trim()
      : node instanceof HTMLParagraphElement && node.children.length === 0
  );
}

function setupLineSplit(scope = document) {
  scope.querySelectorAll('[data-cl-line-split]').forEach((body) => {
    if (lineSplitState.has(body) || !isPlainParagraphs(body)) return;
    const state = { html: body.innerHTML, width: 0, timer: 0 };
    lineSplitState.set(body, state);
    const observer = new ResizeObserver(() => {
      clearTimeout(state.timer);
      state.timer = setTimeout(() => {
        const width = Math.round(body.clientWidth);
        if (!width || width === state.width) return;
        state.width = width;
        splitRenderedLines(body);
      }, 80);
    });
    observer.observe(body);
    splitRenderedLines(body);
  });
}

setupLineSplit();
document.addEventListener('shopify:section:load', event => setupLineSplit(event.target));
document.addEventListener('cl:accordion:open', event => {
  event.detail.item.querySelectorAll('[data-cl-line-split]').forEach((body) => {
    const lines = body.querySelectorAll('.cl-ia__line');
    lines.forEach(line => line.classList.remove('is-visible'));
    void body.offsetWidth;
    window.setTimeout(() => {
      body.querySelectorAll('.cl-ia__line').forEach(line => line.classList.add('is-visible'));
    }, 60);
  });
});
